/** Name and email. The mobile number is how the customer signs in, so it isn't edited here. */

import { errorMessage, patch } from "@taxi/mobile-web/api";
import { phone } from "@taxi/mobile-web/format";
import { goBack } from "@taxi/mobile-web/router";
import { Button, Field, Notice, TopBar, useToast } from "@taxi/mobile-web/ui";
import { type FormEvent, useState } from "react";
import { useMe, useSession } from "../lib/session";
import type { CustomerProfile } from "../lib/types";

export function DetailsScreen() {
  const me = useMe();
  const { setMe, firmPhone } = useSession();
  const toast = useToast();
  const [name, setName] = useState(me.name);
  const [email, setEmail] = useState(me.email ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function save(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      setMe(
        await patch<CustomerProfile>("/customer/me", {
          name: name.trim(),
          email: email.trim() || null,
        }),
      );
      toast("Saved");
      goBack("/account");
    } catch (err) {
      setError(errorMessage(err));
      setBusy(false);
    }
  }

  return (
    <div className="details">
      <TopBar title="Your details" back="/account" />
      <form className="screen-body" onSubmit={save}>
        <Field
          label="Name"
          autoComplete="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <Field
          label="Email"
          type="email"
          autoComplete="email"
          hint="Receipts are emailed here."
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Field
          label="Mobile number"
          value={phone(me.phone)}
          disabled
          hint={`To change it, call us on ${phone(firmPhone)}.`}
        />
        {error && <Notice tone="error">{error}</Notice>}
        <Button type="submit" loading={busy} disabled={!name.trim()}>
          Save
        </Button>
      </form>
    </div>
  );
}
